export const EVENT_ORGANIZATIONS_CSV_TEMPLATE = "id,name,priority";
